import { TPaginate, TResponseType } from '@@types/base';
import { TOrderCreate } from '@@types/order';
import instance from '@apis/instance';
import { analyticsOrderContext } from '../../utils/web-analytics';
import { IOrder } from 'interfaces/order';
import { IYogiyoStore } from 'interfaces/store';
import { invalidateGetResponse } from 'utils/common';

const BASE_ORDER_URL = '/order';

const createOrder = (orderData: TOrderCreate) =>
  instance.post(BASE_ORDER_URL, orderData, { headers: { 'X-Web-Analytics': analyticsOrderContext() } });

const fetchOrders = (queryParams: Record<string, string>) =>
  invalidateGetResponse<TPaginate<IOrder>>({
    url: BASE_ORDER_URL,
    options: { params: queryParams },
  });

const fetchOrderDetails = async (orderId: string) =>
  await invalidateGetResponse<IOrder>({ url: `${BASE_ORDER_URL}/${orderId}` });

const RECENT_ORDERED_STORE_URL = `${BASE_ORDER_URL}/recent`;
const fetchRecentOrderedStores = async () =>
  await invalidateGetResponse<IYogiyoStore[]>({
    url: RECENT_ORDERED_STORE_URL,
  });

const ORDER_DEPOSIT_URL = `${BASE_ORDER_URL}/deposit`;
const updateOrderDeposit = (depositData: { orderId: string; url: string }) =>
  instance.patch(ORDER_DEPOSIT_URL, depositData);

const cancelOrder = (orderId: string) =>
  instance.patch(`${BASE_ORDER_URL}/cancel/${orderId}`);

const updateSoldOut = (soldOutData: {
  orderId: string;
  menu: any;
  option: any;
}) => instance.patch(`${BASE_ORDER_URL}/soldout`, soldOutData);

const checkStoreOpenStatus = (timeRange: { begin: string; end: string }) =>
  invalidateGetResponse<{
    OK: boolean;
    STATUS?: 'OPEN' | 'BEFORE_CLOSE' | 'AFTER_OPEN';
  }>({
    url: `${BASE_ORDER_URL}/store/open/check`,
    options: { params: timeRange },
  });

export default {
  createOrder,
  fetchOrders,
  fetchOrderDetails,
  fetchRecentOrderedStores,
  updateOrderDeposit,
  cancelOrder,
  updateSoldOut,
  checkStoreOpenStatus,
};
